/* tslint:disable */
import { ViewStudyEquipmentForStudy } from './view-study-equipment-for-study';

/**
 */
export class ViewStudyCalculator {
    ID_STUDY?: number;
    STUDY_NAME?: string;
    IS_STUDY_CURRENT?: number;
    row_span?: number;
    studyEquipments?: ViewStudyEquipmentForStudy[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-study-calculator.ts